import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const ButtonContainerWrapper = styled.div`
  margin-bottom: 30px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding: 25px 20px 25px 20px;
    border-bottom: 1px solid #ccc;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    margin-bottom: 0;
  }
`;

const ButtonContainer = ({ children }) => (
  <ButtonContainerWrapper>{children}</ButtonContainerWrapper>
);

ButtonContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ButtonContainer;
